"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closePopover = exports.openPopover = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const popoverSlice = (0, toolkit_1.createSlice)({
    name: "popover",
    initialState: {
        openMarkerKey: null,
        initialSlide: 0,
    },
    reducers: {
        openPopover: (state, action) => {
            state.openMarkerKey = action.payload.markerKey;
            state.initialSlide = action.payload.initialSlide || 0;
        },
        closePopover: (state) => {
            state.openMarkerKey = null;
            state.initialSlide = 0;
        },
    },
});
_a = popoverSlice.actions, exports.openPopover = _a.openPopover, exports.closePopover = _a.closePopover;
exports.default = popoverSlice.reducer;
